import React, { useState } from 'react';
import { Modal, DatePicker, Form } from 'antd';
import dayjs from 'dayjs';

interface GenerateBankFileModalProps {
    visible: boolean;
    onCancel: () => void;
    onConfirm: (asOfDate: dayjs.Dayjs) => Promise<void>;
    loading?: boolean;
}

const GenerateBankFileModal: React.FC<GenerateBankFileModalProps> = ({
    visible,
    onCancel,
    onConfirm,
    loading = false
}) => {
    const [form] = Form.useForm();
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setConfirmLoading(true);
            await onConfirm(values.asOfDate);
            form.resetFields();
        } catch (error) {
            console.error('Form validation failed:', error);
        } finally {
            setConfirmLoading(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <Modal
            title="Generate Bank File"
            open={visible}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={confirmLoading || loading}
            okText="Generate File"
            cancelText="Cancel"
            width={400}
            maskClosable={false}
        >
            <Form
                form={form}
                layout="vertical"
                initialValues={{
                    asOfDate: dayjs().startOf('month')
                }}
            >
                <Form.Item
                    label="As Of Date"
                    name="asOfDate"
                    rules={[{ required: true, message: 'Please select an As Of Date' }]}
                >
                    <DatePicker 
                        style={{ width: '100%' }}
                        format="DD/MM/YYYY"
                        allowClear={false}
                    />
                </Form.Item>
              
            </Form>
        </Modal>
    );
};

export default GenerateBankFileModal;